import { render, staticRenderFns } from "./TaskCRUD.vue?vue&type=template&id=6c259ef9&scoped=true&"
import script from "./TaskCRUD.vue?vue&type=script&lang=js&"
export * from "./TaskCRUD.vue?vue&type=script&lang=js&"
import style0 from "./TaskCRUD.vue?vue&type=style&index=0&id=6c259ef9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c259ef9",
  null
  
)

export default component.exports